import React from "react";
import { Form } from "common/components/Form";
import { Field } from "common/components/Field";
import { Button } from "common/components/Button";
import { RsfFormActions } from "common/reducers/rsfForm.actions";
import { form as formSelector } from "common/selectors/rsfForm.selectors";
import { useSelector } from "react-redux";
import { required } from "common/helpers/FormValidate";
import { RootState } from "common/reducers";

interface ManualEntryProps {
  title: string;
  label: string;
  placeholder: string;
  actionLabel: string;
  context: string;
  onSubmit: any;
}

export const ManualEntry: React.FC<ManualEntryProps> = ({
  title,
  label,
  placeholder,
  actionLabel,
  context,
  onSubmit,
}) => {
  // Constants
  const path = ["rsfForms", "byForm", context];

  // Hooks
  const form = useSelector((state: RootState) => formSelector(state, { name: context }));

  // Local State
  const disabled = !form || !form.get("id");

  // Selectors
  // Methods
  // Lifecycle

  return (
    <div className="flex justify-center w-full">
      <div className="w-[264px] pt-[86px]">
        <Form rootPath={path} onSubmit={onSubmit} updateFormReducer={RsfFormActions.update}>
          <div className="flex flex-col gap-xl w-full">
            <h3 className="text-center">{title}</h3>
            <Field type="inputText" label={label} name="id" placeholder={placeholder} validate={required} />
            <Button variant="primary" type="submit" disabled={disabled} analyticsAction={`${context} submit`}>
              {actionLabel}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};
